var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrifileIconAbout13Kforth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3999 8.79987V9.39987H12.5999V8.79987H11.3999ZM12.5999 8.7892V8.1892H11.3999V8.7892H12.5999ZM12.5999 15.7332V11.4665H11.3999V15.7332H12.5999ZM12.5999 8.79987V8.7892H11.3999V8.79987H12.5999ZM10.3999 12.5999H12.8085V11.3999H10.3999V12.5999ZM10.3999 15.7999H13.5999V14.5999H10.3999V15.7999ZM11.9999 5.1332C15.7922 5.1332 18.8665 8.20751 18.8665 11.9999L20.0665 11.9999C20.0665 7.54477 16.455 3.9332 11.9999 3.9332L11.9999 5.1332ZM5.1332 11.9999C5.1332 8.20751 8.20752 5.1332 11.9999 5.1332L11.9999 3.9332C7.54477 3.9332 3.9332 7.54477 3.9332 11.9999L5.1332 11.9999ZM11.9999 18.8665C8.20751 18.8665 5.1332 15.7922 5.1332 11.9999L3.9332 11.9999C3.9332 16.455 7.54477 20.0665 11.9999 20.0665L11.9999 18.8665ZM11.9999 20.0665C16.455 20.0665 20.0665 16.455 20.0665 11.9999L18.8665 11.9999C18.8665 15.7922 15.7922 18.8665 11.9999 18.8665L11.9999 20.0665Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrifileIconAbout13Kforth);
export default __webpack_public_path__ + "static/media/PrifileIconAbout13Kforth.78ab6d38427067fb8797b20816234ca2.svg";
export { ForwardRef as ReactComponent };